/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	qualityReportStateDic: [{
		name: '待添加',
		value: 0,
		color: 'gray'
	}, {
		name: '待发布',
		value: 1,
		color: 'blue'
	}, {
		name: '已发布',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'red'
	}],
	// 条码子状态（tbl_product_code.state），与 PC 端 productStateDic 同义同值，门店版条码全程停在在库(10)
	productStateDic: [{
		name: '待绑定',
		value: 0,
		color: 'gray'
	}, {
		name: '采购待入库',
		value: 1,
		color: 'green'
	}, {
		name: '销售退货待入库',
		value: 2,
		color: 'blue'
	}, {
		name: '在库',
		value: 10,
		color: 'gray'
	}, {
		name: '质检调拨中',
		value: 11,
		color: 'blue'
	}, {
		name: '质检中',
		value: 12,
		color: 'green'
	}, {
		name: '质检调拨返库中',
		value: 13,
		color: 'blue'
	}, {
		name: '质检驳回返库中',
		value: 14,
		color: 'red'
	}, {
		name: '质检驳回中',
		value: 16,
		color: 'red'
	}, {
		name: '维修调拨中',
		value: 21,
		color: 'blue'
	}, {
		name: '维修中',
		value: 22,
		color: 'green'
	}, {
		name: '维修返库中',
		value: 23,
		color: 'blue'
	}, {
		name: '维修驳回返库中',
		value: 24,
		color: 'red'
	}, {
		name: '维修驳回中',
		value: 26,
		color: 'red'
	}, {
		name: '销售调拨中',
		value: 31,
		color: 'blue'
	}, {
		name: '销售中',
		value: 32,
		color: 'green'
	}, {
		name: '销售返库中',
		value: 33,
		color: 'blue'
	}, {
		name: '销售驳回返库中',
		value: 34,
		color: 'red'
	}, {
		name: '销售驳回中',
		value: 36,
		color: 'red'
	}, {
		name: '采购退库',
		value: 41,
		color: 'gray'
	}, {
		name: '销售出库',
		value: 42,
		color: 'green'
	}, {
		name: '分润调拨出库',
		value: 43,
		color: 'blue'
	}],
	// 销售商品总体状态（tbl_sale_product.overall_state），与 PC 端 saleOverallStateDic 同义同值
	saleOverallStateDic: [{
		name: '待上架',
		value: 1,
		color: 'gray'
	}, {
		name: '已上架',
		value: 2,
		color: 'green'
	}, {
		name: '已下架',
		value: 3,
		color: 'orange'
	}, {
		name: '锁定中',
		value: 4,
		color: 'red'
	}, {
		name: '已售出',
		value: 5,
		color: 'green'
	}],
	qualityStateDic: [{
		name: '待质检',
		value: 1,
		color: 'gray'
	}, {
		name: '已质检',
		value: 2,
		color: 'green'
	}, {
		name: '返库中',
		value: 3,
		color: 'orange'
	}, {
		name: '已返库',
		value: 4,
		color: 'red'
	}, {
		name: '已调出',
		value: 5,
		color: 'blue'
	}, {
		name: '调拨中',
		value: 8,
		color: 'orange'
	}, {
		name: '被驳回中',
		value: 9,
		color: 'red'
	}],
}